/* Mayfly Studios - auto-cycle product cards between the printed side and the reverse.
 *
 * Horizon already swaps the card image on hover, via its own previewImage /
 * resetImage handlers bound declaratively on .card-gallery. Rather than
 * reimplement that, fire those same handlers on a timer so the cycling matches
 * hover exactly and keeps working if the theme updates.
 *
 * Media order is [printed side, other side, flat-lay composite], so slide 0 is
 * always the side carrying the design.
 */
(function () {
  if (typeof window === 'undefined') return;

  var DESIGN_MS = 2600; // dwell on the printed side
  var OTHER_MS = 1400;  // dwell on the reverse
  var STAGGER = 450;    // offset per card so a row does not flip in unison

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var timers = new WeakMap();
  var hovered = new WeakSet();
  var failed = new WeakSet(); // cards where the synthetic events did nothing

  function fire(el, type) {
    el.dispatchEvent(new PointerEvent(type, { bubbles: false, cancelable: true, pointerType: 'mouse' }));
  }

  // Fallback for cards that ignore synthetic events: drive the scroller directly.
  function slideTo(card, second) {
    var scroller = card.querySelector('slideshow-slides');
    if (!scroller) return;
    scroller.scrollTo({ left: second ? scroller.clientWidth : 0, behavior: 'smooth' });
  }

  function visibleSlideId(card) {
    var on = card.querySelector('slideshow-slide[aria-hidden="false"]');
    return on ? on.getAttribute('slide-id') : null;
  }

  function start(card) {
    if (timers.has(card)) return;
    if (card.querySelectorAll('slideshow-slide').length < 2) return;

    var second = false;

    function step() {
      // Never fight a real cursor, and do not animate a backgrounded tab.
      if (document.hidden || hovered.has(card)) {
        timers.set(card, setTimeout(step, OTHER_MS));
        return;
      }

      second = !second;
      var before = visibleSlideId(card);

      if (failed.has(card)) {
        slideTo(card, second);
      } else {
        fire(card, second ? 'pointerenter' : 'pointerleave');
        // If the theme's handler did not move anything, switch this card to the
        // fallback. Deliberately a timer rather than requestAnimationFrame:
        // rAF is frozen in background tabs and under power saving, which would
        // strand this check and leave the card stuck on one side forever.
        setTimeout(function () {
          if (visibleSlideId(card) === before) {
            failed.add(card);
            slideTo(card, second);
          }
        }, 120);
      }

      timers.set(card, setTimeout(step, second ? OTHER_MS : DESIGN_MS));
    }

    var offset = (Number(card.dataset.mfCycle) || 0) % 4;
    timers.set(card, setTimeout(step, DESIGN_MS + offset * STAGGER));
  }

  function stop(card) {
    clearTimeout(timers.get(card));
    timers.delete(card);
    if (failed.has(card)) slideTo(card, false);
    else fire(card, 'pointerleave');
  }

  var io = window.IntersectionObserver
    ? new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          if (e.isIntersecting) start(e.target);
          else stop(e.target);
        }
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.25 })
    : null;

  var n = 0;
  function scan() {
    var cards = document.querySelectorAll('.card-gallery');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.dataset.mfCycle !== undefined) continue;
      card.dataset.mfCycle = n++;
      // isTrusted separates a real cursor from the events dispatched here.
      card.addEventListener('pointerenter', (function (c) {
        return function (e) { if (e.isTrusted) hovered.add(c); };
      })(card));
      card.addEventListener('pointerleave', (function (c) {
        return function (e) { if (e.isTrusted) hovered.delete(c); };
      })(card));
      // Start unconditionally. IntersectionObserver is only ever used to pause
      // cards that scroll out of view, so a browser that delivers no entries
      // (or delivers them late) still animates rather than sitting frozen.
      if (io) io.observe(card);
      start(card);
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  ready(function () {
    scan();

    // Filtering, sorting and infinite scroll re-render cards.
    if (window.MutationObserver) {
      var queued;
      new MutationObserver(function () {
        clearTimeout(queued);
        queued = setTimeout(scan, 200);
      }).observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        var cards = document.querySelectorAll('.card-gallery');
        for (var i = 0; i < cards.length; i++) stop(cards[i]);
      } else {
        scan();
      }
    });
  });
})();
